module.exports = __webpack_public_path__ + "img/business_01.7b020889.png";